export default __webpack_public_path__ + "static/media/youtube.d9709cce.svg";